import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const PreseVisione = ({ noteId }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/novita/${noteId}/prese-visione`).then(({ data }) => setD(data)).catch(() => setD({ utenti: [], lette: 0, totale: 0 })); }, [noteId]);
  if (!d) return <p className="mt-2 text-sm text-slate-400">Caricamento…</p>;
  return (
    <div className="mt-3 rounded-lg border border-slate-100 bg-slate-50 p-3" data-testid={`prese-visione-${noteId}`}>
      <p className="text-sm font-medium text-slate-700 mb-2" data-testid={`prese-visione-conteggio-${noteId}`}>Presa visione: {d.lette} su {d.totale}</p>
      <div className="divide-y divide-slate-200">
        {d.utenti.map((u) => (
          <div key={u.user_id} className="flex items-center justify-between py-1.5 text-sm" data-testid={`presa-visione-riga-${u.user_id}`}>
            <span className="text-slate-700">{u.nome} <span className="text-slate-400">· {u.email}</span></span>
            {u.letta_il
              ? <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100">Letta il {fmt(u.letta_il)}</Badge>
              : <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-100">Non ancora</Badge>}
          </div>
        ))}
      </div>
    </div>
  );
};
